import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Drawer, IconButton } from 'seagull';
import { MenuIcon } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import HomeSidebar from '../../HomeSidebar/HomeSidebar';
import styles from './SidebarMenu.module.scss';
export const getSidebarMenuTID = ()=>getTestIds();
export function SidebarMenu() {
    const { SidebarMenuTID } = useMemo(()=>getSidebarMenuTID(), []);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();
    useEffect(()=>{
        setIsMenuOpen(false);
    }, [
        location.pathname
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(IconButton, {
                bi: {
                    name: 'open_sidebar_menu'
                },
                noPadding: true,
                size: "small",
                testId: SidebarMenuTID.MenuButton(),
                onClick: ()=>setIsMenuOpen(true),
                children: /*#__PURE__*/ _jsx(MenuIcon, {})
            }),
            /*#__PURE__*/ _jsx(Drawer, {
                bi: {
                    name: 'sidebar_menu_drawer'
                },
                disableMobileBottomSheet: true,
                testId: SidebarMenuTID.Drawer(),
                anchor: "left",
                open: isMenuOpen,
                onClose: ()=>setIsMenuOpen(false),
                onCloseButtonClick: ()=>setIsMenuOpen(false),
                minWidth: 200,
                children: /*#__PURE__*/ _jsx("div", {
                    className: styles.drawer,
                    children: /*#__PURE__*/ _jsx(HomeSidebar, {
                        disableAutoNavigateGroup: true
                    })
                })
            })
        ]
    });
}
